export default __webpack_public_path__ + "static/media/bite-closed-logo.70f81511.svg";